import { render } from "./LoginCallbackPage.vue?vue&type=template&id=c30bee34&ts=true"
import script from "./LoginCallbackPage.vue?vue&type=script&lang=ts"
export * from "./LoginCallbackPage.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__